<template lang="html">
  <div class="ai-input-group">
    <input ref="input"
           :type="type"
           class="ai-input ai-input-group__input"
           :value="value"
           :placeholder="placeholder"
           @input="onInputValueChange">
    <div class="ai-button ai-input-group__button">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiInputGroup',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      input: null
    };
  },
  mounted() {
    this.input = this.$refs.input;
  },
  methods: {
    onInputValueChange() {
      let val = this.input.value;
      if (this.type === 'number') {
        if (Number.isNaN(Number(val))) return;
        val = Number(val);
      }
      this.$emit('input', val);
    }
  }
};
</script>
